export const DEFAULT_SDK_INIT_TIMEOUT_IN_SECONDS = 7;
